<script setup lang="ts">
interface Props {
    icon: string
    count: number
    size?: string | number
    class?: string
}

const props = withDefaults(defineProps<Props>(), {
    size: '16',
    class: ''
})
</script>

<template>
    <v-tooltip
        location="top"
        :content-class="`bg-black border-sm text-tooltip ${props.class}`"
        max-width="200"
    >
        <template #activator="{ props: bind }">
            <div v-bind="bind">
                <v-icon
                    :size="props.size"
                    class="mr-1"
                    color="grey-darken-2"
                >
                    {{ props.icon }}
                </v-icon>
                <span class="custom-text text-medium-emphasis">{{ props.count }}</span>
            </div>
        </template>
        <slot />
    </v-tooltip>
</template>

<style scoped>
.custom-text {
    font-size: 0.875rem; /* 14px */
}
</style>
